import * as StripeTypes from "../../../Common/Stripe/types";

export interface IStripe {
    stripeState: StripeState;
    cardInfo: StripeTypes.ICardInfo;
    idempotencyKey?: string;
    isCreditCardEdit: boolean;

    updateFieldCallback?: (value) => void;
}

export enum StripeState {
    None,
    Show,
}
